var _path, _circle, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconDpoUpload = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M60.87 52.17H8.5a2.32 2.32 0 0 1-2.32-2.32V16.38A3.36 3.36 0 0 1 9.53 13h51.34a2.32 2.32 0 0 1 2.32 2.32v34.5a2.32 2.32 0 0 1-2.32 2.35ZM9.53 14.53a1.85 1.85 0 0 0-1.85 1.85v33.47a.82.82 0 0 0 .82.82h52.37a.82.82 0 0 0 .82-.82v-34.5a.82.82 0 0 0-.82-.82Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.97,
    cy: 47.85,
    r: 12.15,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M34 60.75a12.9 12.9 0 1 1 12.9-12.9A12.92 12.92 0 0 1 34 60.75Zm0-24.3a11.4 11.4 0 1 0 11.4 11.4A11.41 11.41 0 0 0 34 36.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M34 53.91a.76.76 0 0 1-.75-.75V43a.75.75 0 0 1 1.5 0v10.16a.76.76 0 0 1-.75.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M39.48 48.83a.75.75 0 0 1-.53-.22l-5-5-5 5a.75.75 0 0 1-1.06-1.06L33.44 42a.77.77 0 0 1 1.06 0l5.5 5.55a.75.75 0 0 1 0 1.06.79.79 0 0 1-.52.22ZM1.56 46.06a.75.75 0 0 1-.75-.75V6.72a3.47 3.47 0 0 1 3.46-3.47h9.17a2.4 2.4 0 0 1 2.4 2.4v1.12a1 1 0 0 0 1 1h25.83a.75.75 0 1 1 0 1.5H16.86a2.52 2.52 0 0 1-2.52-2.52v-1.1a.9.9 0 0 0-.9-.9H4.27a2 2 0 0 0-2 2v38.56a.76.76 0 0 1-.71.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M11.33 8.82H4.85a.75.75 0 0 1 0-1.5h6.48a.75.75 0 0 1 0 1.5Z"
  })));
};
export default SvgIconDpoUpload;